import React from 'react'
import CustomCollapse from '../components/custom-collapse/custom-collapse';
import { CommonStyle } from '../styles/common-styles';
import Link from 'next/link';
import Head from 'next/head';
import { faqLeft, faqRight } from '../utils/wordings';

function FAQ() {

    return (
        <div className="container-fluid p-0 mt-5">
            <Head>
                <title>Paleo Car Care - Expert Auto Maintenance for Your Peace of Mind</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="description" content="Discover the best in auto care with Paleo Car Care - Your trusted partner for top-notch car maintenance services." />
                <meta name="author" content="Paleo Car Care" />
                <meta property="og:title" content="Paleo Car Care - Frequently Asked Questions: Your Guide to Auto Services" />
                <meta property="og:image" itemProp="image" content="/images/referral-banner.png" />
                <meta name="facebook-domain-verification" content="m4o6pn81efn34qkf6t3fimmjnhbuxs" />
                <link rel="shortcut icon" href="../public/assets/images/favicon.ico" />
                <link rel="shortcut icon" href="/favicon.ico" />
                <link rel="alternate" href="https://www.paleocarcare.com/faq.html" hrefLang="en" />
            </Head>
            <CommonStyle>
                <div className='container '>
                    <div className='caption'>
                        <h1 className='heavy-bold'>Frequently Asked Questions</h1>
                    </div>
                    <div className='FAQ-list mb-5 d-lg-flex justify-content-between'>
                        <div className='col-lg-5'>
                            <CustomCollapse collapseItems={faqLeft} bodyBg={'#fff'} />
                        </div>
                        <div className='col-lg-5'>
                            <CustomCollapse collapseItems={faqRight} bodyBg={'#fff'} />
                        </div>
                    </div>
                    <div className='text-center mb-5'>
                        <Link href={'/contactus.html'}>
                            <button className='w-100 w-md-auto btn btn-danger p-3'>Contact Us</button>
                        </Link>
                    </div>
                </div>
            </CommonStyle>
        </div>
    )
};

export default FAQ;